import React from 'react';
import MenuHoi from 'components/MenuHoi';
import { ButtonWidgetAdd } from 'components/buttons';

const PopoverMenu = ({ actions, button = <ButtonWidgetAdd /> }) => {
    return <MenuHoi items={actions}>{button}</MenuHoi>;
};

export default PopoverMenu;
